"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEstimatedDelayBetweenChunksMillis = exports.useGetHasAllowance = exports.useChangeNetwork = exports.useTwapContract = exports.useContract = exports.usemElipsisAddress = exports.useGetTokenFromParsedTokensList = exports.useTokenFromParsedTokensList = exports.useOpenOrders = exports.useTokenBalance = exports.useExplorerUrl = exports.useNetwork = exports.useInvertPrice = exports.useInvertedPrice = exports.useDebounce = exports.useAmountBN = exports.useAmountUi = exports.useFormatDecimals = exports.useFormatNumberV2 = exports.useFormatNumber = exports.useDstBalance = exports.useSrcBalance = exports.useResetAfterSwap = exports.useRefetchBalances = void 0;
var context_1 = require("../context/context");
var react_1 = require("react");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var types_1 = require("../types");
var web3_candies_1 = require("@defi.org/web3-candies");
var twap_abi_json_1 = __importDefault(require("@orbs-network/twap/twap.abi.json"));
var react_number_format_1 = require("react-number-format");
var utils_1 = require("../utils");
var query_1 = require("./query");
var actions_1 = require("../context/actions");
var useRefetchBalances = function () {
    var refetchSrcBalance = (0, exports.useSrcBalance)().refetch;
    var refetchDstBalance = (0, exports.useDstBalance)().refetch;
    return (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all([refetchSrcBalance(), refetchDstBalance()])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [refetchSrcBalance, refetchDstBalance]);
};
exports.useRefetchBalances = useRefetchBalances;
var useResetAfterSwap = function () {
    var resetAfterSwap = actions_1.stateActions.useSwapReset();
    var refetchBalances = (0, exports.useRefetchBalances)();
    return (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    resetAfterSwap();
                    (0, utils_1.resetQueryParams)();
                    return [4 /*yield*/, refetchBalances()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [resetAfterSwap, refetchBalances]);
};
exports.useResetAfterSwap = useResetAfterSwap;
var useSrcBalance = function () {
    var srcToken = (0, context_1.useTwapContext)().srcToken;
    return query_1.query.useBalance(srcToken);
};
exports.useSrcBalance = useSrcBalance;
var useDstBalance = function () {
    var dstToken = (0, context_1.useTwapContext)().dstToken;
    return query_1.query.useBalance(dstToken);
};
exports.useDstBalance = useDstBalance;
var useFormatNumber = function (_a) {
    var _b;
    var value = _a.value, _c = _a.decimalScale, decimalScale = _c === void 0 ? 3 : _c, prefix = _a.prefix, suffix = _a.suffix, _d = _a.disableDynamicDecimals, disableDynamicDecimals = _d === void 0 ? true : _d;
    var disableThousandSeparator = (0, context_1.useTwapContext)().uiPreferences.disableThousandSeparator;
    var result = (0, react_number_format_1.useNumericFormat)({
        allowLeadingZeros: true,
        thousandSeparator: disableThousandSeparator ? "" : ",",
        displayType: "text",
        value: value || "",
        decimalScale: decimalScale || 18,
        prefix: prefix,
        suffix: suffix,
    });
    return (_b = result.value) === null || _b === void 0 ? void 0 : _b.toString();
};
exports.useFormatNumber = useFormatNumber;
var useFormatNumberV2 = function (_a) {
    var _b;
    var value = _a.value, _c = _a.decimalScale, decimalScale = _c === void 0 ? 3 : _c, prefix = _a.prefix, suffix = _a.suffix;
    var _value = (0, exports.useFormatDecimals)(value, decimalScale);
    var disableThousandSeparator = (0, context_1.useTwapContext)().uiPreferences.disableThousandSeparator;
    var result = (0, react_number_format_1.useNumericFormat)({
        allowLeadingZeros: true,
        thousandSeparator: disableThousandSeparator ? "" : ",",
        displayType: "text",
        value: _value || "",
        decimalScale: 18,
        prefix: prefix,
        suffix: suffix,
    });
    return (_b = result.value) === null || _b === void 0 ? void 0 : _b.toString();
};
exports.useFormatNumberV2 = useFormatNumberV2;
var useFormatDecimals = function (value, decimalPlaces) {
    return (0, react_1.useMemo)(function () { return (0, utils_1.formatDecimals)(value, decimalPlaces); }, [value, decimalPlaces]);
};
exports.useFormatDecimals = useFormatDecimals;
var useAmountUi = function (decimals, value) {
    return (0, react_1.useMemo)(function () {
        if (!decimals || !value)
            return;
        return (0, utils_1.amountUiV2)(decimals, value);
    }, [decimals, value]);
};
exports.useAmountUi = useAmountUi;
var useAmountBN = function (decimals, value) {
    return (0, react_1.useMemo)(function () {
        if (!decimals || !value)
            return;
        return (0, utils_1.amountBNV2)(decimals, value);
    }, [decimals, value]);
};
exports.useAmountBN = useAmountBN;
function useDebounce(value, delay) {
    var _a = (0, react_1.useState)(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    (0, react_1.useEffect)(function () {
        var timer = setTimeout(function () { return setDebouncedValue(value); }, delay);
        return function () {
            clearTimeout(timer);
        };
    }, [value, delay]);
    return debouncedValue;
}
exports.useDebounce = useDebounce;
var useInvertedPrice = function (price, inverted) {
    return (0, react_1.useMemo)(function () {
        if (!price)
            return "";
        return inverted ? (0, bignumber_js_1.default)(1).div(price).toString() : price;
    }, [price, inverted]);
};
exports.useInvertedPrice = useInvertedPrice;
var useInvertPrice = function (price) {
    var _a = (0, react_1.useState)(false), inverted = _a[0], setInvert = _a[1];
    var _b = (0, context_1.useTwapContext)(), srcToken = _b.srcToken, dstToken = _b.dstToken;
    var invertedPrice = (0, exports.useInvertedPrice)(price, inverted);
    var value = (0, exports.useFormatNumber)({ value: invertedPrice || "", decimalScale: 5 });
    var onInvert = (0, react_1.useCallback)(function () {
        setInvert(function (prev) { return !prev; });
    }, [setInvert]);
    var leftToken = inverted ? dstToken : srcToken;
    var rightToken = inverted ? srcToken : dstToken;
    return {
        price: value,
        leftToken: leftToken,
        rightToken: rightToken,
        inverted: inverted,
        onInvert: onInvert,
    };
};
exports.useInvertPrice = useInvertPrice;
var useNetwork = function () {
    var config = (0, context_1.useTwapContext)().config;
    return (0, react_1.useMemo)(function () {
        return Object.values(web3_candies_1.networks).find(function (network) { return network.id === config.chainId; });
    }, [config]);
};
exports.useNetwork = useNetwork;
var useExplorerUrl = function () {
    var config = (0, context_1.useTwapContext)().config;
    return (0, react_1.useMemo)(function () { return (0, utils_1.getExplorerUrl)(config.chainId); }, [config.chainId]);
};
exports.useExplorerUrl = useExplorerUrl;
var useTokenBalance = function (isSrc) {
    var _a, _b;
    var _c = (0, context_1.useTwapContext)(), srcToken = _c.srcToken, dstToken = _c.dstToken;
    var srcBalance = (0, exports.useAmountUi)(srcToken === null || srcToken === void 0 ? void 0 : srcToken.decimals, (_a = (0, exports.useSrcBalance)().data) === null || _a === void 0 ? void 0 : _a.toString());
    var dstBalance = (0, exports.useAmountUi)(dstToken === null || dstToken === void 0 ? void 0 : dstToken.decimals, (_b = (0, exports.useDstBalance)().data) === null || _b === void 0 ? void 0 : _b.toString());
    return isSrc ? srcBalance : dstBalance;
};
exports.useTokenBalance = useTokenBalance;
var useOpenOrders = function () {
    var data = query_1.query.useOrdersHistory().data;
    return (0, react_1.useMemo)(function () {
        return !data ? undefined : data[types_1.Status.Open];
    }, [data]);
};
exports.useOpenOrders = useOpenOrders;
var useTokenFromParsedTokensList = function (address) {
    var getTokenFromList = (0, exports.useGetTokenFromParsedTokensList)();
    return (0, react_1.useMemo)(function () { return getTokenFromList(address); }, [address]);
};
exports.useTokenFromParsedTokensList = useTokenFromParsedTokensList;
var useGetTokenFromParsedTokensList = function () {
    var tokens = (0, context_1.useTwapContext)().tokens;
    return (0, react_1.useCallback)(function (address) {
        return tokens.find(function (token) { return (0, web3_candies_1.eqIgnoreCase)(address || "", token.address || ""); });
    }, [tokens]);
};
exports.useGetTokenFromParsedTokensList = useGetTokenFromParsedTokensList;
var usemElipsisAddress = function (address) {
    var addressPadding = (0, context_1.useTwapContext)().uiPreferences.addressPadding;
    return (0, react_1.useMemo)(function () {
        return (0, utils_1.makeElipsisAddress)(address, addressPadding);
    }, [addressPadding, address]);
};
exports.usemElipsisAddress = usemElipsisAddress;
var useContract = function (abi, address) {
    var _a;
    var _b = (0, context_1.useTwapContext)(), config = _b.config, web3 = _b.web3;
    var wTokenAddress = (_a = (0, web3_candies_1.network)(config.chainId)) === null || _a === void 0 ? void 0 : _a.wToken.address;
    return (0, react_1.useMemo)(function () {
        if (!web3 || !address || !config || !abi)
            return;
        if ((0, web3_candies_1.isNativeAddress)(address)) {
            return new web3.eth.Contract(abi || [], wTokenAddress);
        }
        return new web3.eth.Contract(abi || [], address);
    }, [abi, address, config, web3, wTokenAddress]);
};
exports.useContract = useContract;
var useTwapContract = function () {
    var config = (0, context_1.useTwapContext)().config;
    return (0, exports.useContract)(twap_abi_json_1.default, config.twapAddress);
};
exports.useTwapContract = useTwapContract;
var useChangeNetwork = function () {
    var config = (0, context_1.useTwapContext)().config;
    var _a = (0, react_1.useState)(false), loading = _a[0], setLoading = _a[1];
    var changeNetwork = function (onSuccess, onError) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, web3_candies_1.switchMetaMaskNetwork)(config.chainId)];
                case 1:
                    _a.sent();
                    onSuccess();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    onError();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onChangeNetwork = function () { return __awaiter(void 0, void 0, void 0, function () {
        var onSuccess, onError;
        return __generator(this, function (_a) {
            onSuccess = function () {
                setLoading(false);
            };
            onError = function () {
                setLoading(false);
            };
            setLoading(true);
            changeNetwork(onSuccess, onError);
            return [2 /*return*/];
        });
    }); };
    return {
        changeNetwork: onChangeNetwork,
        loading: loading,
    };
};
exports.useChangeNetwork = useChangeNetwork;
var useGetHasAllowance = function () {
    var _a;
    var wToken = (_a = (0, exports.useNetwork)()) === null || _a === void 0 ? void 0 : _a.wToken;
    var _b = (0, context_1.useTwapContext)(), account = _b.account, config = _b.config;
    return (0, react_1.useCallback)(function (token, amount) { return __awaiter(void 0, void 0, void 0, function () {
        var contract, allowance, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!wToken)
                        return [2 /*return*/];
                    token = token && (0, web3_candies_1.isNativeAddress)(token === null || token === void 0 ? void 0 : token.address) ? wToken : token;
                    contract = (0, web3_candies_1.erc20)(token.symbol, token.address, token.decimals);
                    _a = bignumber_js_1.default;
                    return [4 /*yield*/, contract.methods.allowance(account, config.twapAddress).call()];
                case 1:
                    allowance = _a.apply(void 0, [_b.sent()]);
                    return [2 /*return*/, allowance.gte(amount)];
            }
        });
    }); }, [account, config, wToken]);
};
exports.useGetHasAllowance = useGetHasAllowance;
var useEstimatedDelayBetweenChunksMillis = function () {
    var config = (0, context_1.useTwapContext)().config;
    return (0, react_1.useMemo)(function () {
        return config.bidDelaySeconds * 1000 * 2;
    }, [config]);
};
exports.useEstimatedDelayBetweenChunksMillis = useEstimatedDelayBetweenChunksMillis;
